import {
    StyleSheet,
    Platform,
    View,
} from "react-native";
import { useTheme } from "@react-navigation/native";
import { useCallback, useEffect, useState } from "react";
import { Controller } from 'react-hook-form';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import DropDownPicker from "react-native-dropdown-picker";
import { useTranslation } from "react-i18next";
import MultiSelect from 'react-native-multiple-select';

const CustomControlledMultiDropdown = ({
    control, name,
    rules = {},
    type = "PRIMARY", disabled = false, options = [], placeholder = null, loading = false, multiple = true,
    direction = "BOTTOM",
}) => {
    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [internalValue, setInternalValue] = useState(multiple ? [] : null);

    return (
        <View style={[
            styles.container,
            styles[`container_${type}`],
            { flex: 1 }
        ]}>
            <Controller
                control={control}
                name={name}
                rules={rules}
                defaultValue={multiple ? [] : null}
                render={({ field: { onChange, value } }) => (
                    <MultiSelect
                        items={options}
                        uniqueKey="value"
                        onSelectedItemsChange={(val) => {
                            if (Array.isArray(val) && val.length === 0) {
                                // onChange(null);
                                onChange([]);
                            } else if (JSON.stringify(val) !== JSON.stringify(internalValue)) {
                                onChange(val);
                                setInternalValue(val);
                            }
                        }}
                        selectedItems={value}
                        selectText={value.length === 0 ? (placeholder !== null ? placeholder : t('common:selectItem')) : ''}
                        searchInputPlaceholderText={`${t('common:search')}...`}
                        onChangeInput={(text) => console.log(text)}
                        tagRemoveIconColor="#CCC"
                        tagBorderColor="#CCC"
                        tagTextColor="#CCC"
                        selectedItemTextColor="#CCC"
                        selectedItemIconColor="#CCC"
                        itemTextColor="#000"
                        displayKey="label"
                        searchInputStyle={{ color: '#CCC' }}
                        submitButtonColor="#CCC"
                        submitButtonText={t('common:submit')}
                        disabled={disabled}
                        styleDropdownMenuSubsection={[
                            { borderColor: 'transparent' },
                            // styles[`dropdown_${type}`],
                        ]}
                        
                        styleInputGroup={styles.listItemContainerStyle}
                        styleItemsContainer={styles.listItemLabelStyle}
                        styleTextDropdown={styles.labelStyle}
                        styleTextDropdownSelected={Array.isArray(value) && value.length === 0 ? [styles.labelStyle, styles.emptySelected] : styles.labelStyle}
                        styleListContainer={styles.modalContentContainerStyle}
                        styleSearchBar={styles.searchContainerStyle}
                        styleTextInput={styles.searchTextInputStyle}
                        styleTextTag={styles.listMessageTextStyle}
                        hideSubmitButton={true}
                        hideTags={true}
                        selectedItemFontFamily={Platform.OS === 'web' ? 'SCROLLVIEW' : 'MODAL'}
                        modalAnimationType="fade"
                        ArrowDownIconComponent={() => (
                            <Ionicons name="arrow-down-circle" style={styles.icon} />  // Custom down arrow icon
                        )}
                        ArrowUpIconComponent={() => (
                            <Ionicons name="arrow-up-circle" style={styles.icon} />  // Custom up arrow icon
                        )}
                        TickIconComponent={() => (
                            <Ionicons name="checkmark-sharp" style={styles.checkmark} />
                        )}
                        CloseIconComponent={() => (
                            <Ionicons name="close-sharp" style={styles.close} />
                        )}
                        autoScroll={true}
                        translation={{
                            NOTHING_TO_SHOW: t('common:noResultsFound'),
                        }}
                    />
                )}
            />
        </View>
    );
};


const makeStyles = (colors) => StyleSheet.create({
    container: {
        borderColor: "#e8e8e8",
        borderWidth: 9,
    },
    container_MYPROFILE: {
        width: '100%',
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        borderColor: colors.border_card,
        padding: 10,
    },

    input_MYPROFILE: {
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 0,
    },

    container_PART: {
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        borderColor: colors.border_card,
        margin: 10,
    },

    input_PART: {
        fontSize: 16,
        color: colors.text_primary,
    },

    container_PRIMARY: {
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        width: '60%',
    },

    container_FULL: {
        flex: 1,
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderColor: colors.border_card,
        borderWidth: 2,
        width: '94%',
        marginVertical: 5,
    },
    container_ASSM: {
        flex: 1,
        backgroundColor: colors.background_dropdown,
        zIndex: '1',
        borderRadius: 10,
        borderWidth: 2,
        borderColor: colors.border_card,
        width: '90%',
        padding: 10,
        height: '60%',
        margin: 10,
    },
    input_ASSM: {
        fontSize: 12,
        color: colors.text_primary,
        paddingHorizontal: 0,
    },
    icon: {
        fontSize: 20,
        color: '#a1a1a1',
        paddingRight: 10,
    },

    listItemContainerStyle: {
        height: 60,
        borderColor: colors.border_card,

    },

    listItemLabelStyle: {
        fontSize: 16,
        color: colors.text_primary,
        paddingRight: 15,
        fontFamily: 'Roboto-Medium',
    },

    itemSeparatorStyle: {
        backgroundColor: "#a1a1a147",
    },

    labelStyle: {
        fontSize: 16,
        paddingHorizontal: 5,
        color: colors.text_primary,
        paddingRight: 30,
        fontFamily: 'Roboto-Medium',
    },

    emptySelected: {
        color: '#a1a1a1',
    },

    placeholderStyle: {
        color: "#a1a1a1",
        fontSize: 16,
        paddingHorizontal: 5,
        fontFamily: 'Roboto-Medium',
    },

    searchContainerStyle: {
        borderBottomColor: "#e8e8e8",
    },

    searchTextInputStyle: {
        fontSize: 16,
        fontFamily: 'Roboto-Medium',
        color: colors.text_primary,
        borderColor: colors.border_card,
    },

    modalContentContainerStyle: {
        backgroundColor: colors.background_dropdown_with_icons,
        maxHeight: 100
    },

    listMessageTextStyle: {
        fontSize: 16,
        fontFamily: 'Roboto-Medium',
        color: colors.text_primary,
    },

    checkmark: {
        fontSize: 20,
        color: colors.buttons_primary,
    },

    close: {
        fontSize: 30,
        color: '#a1a1a1',
    },

    container_NEW_DOCUMENT: {
        flex: 1,
        width: '98%',
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        padding: 10,
        margin: 10,
        borderColor: colors.border_card,
    },

    input_NEW_DOCUMENT: {
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 0,
    },

    container_SELECT_EMPLOYEE: {
        flex: 1,
        width: '98%',
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        padding: 10,
        margin: 10,
        marginTop: 5,
        borderColor: colors.border_card,
    },

    input_SELECT_EMPLOYEE: {
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 0,
    },

    container_EDIT_EMPLOYEE: {
        borderRadius: 10,
        borderWidth: 2,
        flex: 1,
        width: "100%",
        padding: 7,
        margin: 5,
        marginHorizontal: '5%'
    },

    dropdown_EDIT_EMPLOYEE: {
        minHeight: 300,
        borderColor: colors.border_card,
        padding: 7,
        margin: 5,
        marginHorizontal: '5%'
    },

    container_EDIT_EMPLOYEE_REQUIRED: {
        borderRadius: 10,
        borderWidth: 2,
        flex: 1,
        width: "100%",
        padding: 7,
        margin: 5,
        marginHorizontal: '5%'
    },

    dropdown_EDIT_EMPLOYEE_REQUIRED: {
        minHeight: 300,
        borderColor: colors.background_rejected,
        padding: 7,
        margin: 5,
        marginHorizontal: '5%'
    },

    container_SERVLINES: {
        flex: 1,
        width: "90%",
        marginLeft: "3%",
    },

    container_DEPARTMENTS: {
        borderWidth: 2,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        flex: 1,
        borderRadius: 10,
        width: "90%",
        marginLeft: "3%",
        padding: 4,
    },


});
const pickerSelectStyle = (colors) => StyleSheet.create({

    inputIOS: {
        fontSize: 16,
        borderRadius: 10,
        borderColor: colors.border_card,
        borderWidth: 2,
        paddingVertical: 10,
        paddingHorizontal: 6,
        color: colors.text_primary,
        backgroundColor: colors.background_dropdown,
        paddingRight: 30, // to ensure the text is never behind the icon
        paddingLeft: 10,
        fontFamily: 'Roboto-Medium',
        overflow: 'hidden', // to hide overflow text
        textOverflow: 'ellipsis', // to add ellipsis for overflow text
    },

    inputAndroid: {
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 5,
        backgroundColor: colors.background_dropdown,
        paddingRight: 30, // to ensure the text is never behind the icon
        fontFamily: 'Roboto-Medium',
        overflow: 'hidden', // to hide overflow text
        textOverflow: 'ellipsis', // to add ellipsis for overflow text
    },

    inputWeb: {
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 5,
        backgroundColor: colors.background_dropdown,
        paddingRight: 30, // to ensure the text is never behind the icon
        fontFamily: 'Roboto-Medium',
        outlineStyle: 'none',    // remove dropdown outline
        marginRight: 5,
        overflow: 'hidden', // to hide overflow text
        textOverflow: 'ellipsis', // to add ellipsis for overflow text
    },

    placeholder: {
        color: '#a1a1a1',
    },
});

export default CustomControlledMultiDropdown;
